import { render, staticRenderFns } from "./adminPage.vue?vue&type=template&id=0fea87e3&"
import script from "./adminPage.vue?vue&type=script&lang=js&"
export * from "./adminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports